import { render, staticRenderFns } from "./StepTitle.vue?vue&type=template&id=68fac76d&scoped=true&"
import script from "./StepTitle.vue?vue&type=script&lang=js&"
export * from "./StepTitle.vue?vue&type=script&lang=js&"
import style0 from "./StepTitle.vue?vue&type=style&index=0&id=68fac76d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fac76d",
  null
  
)

export default component.exports